document.addEventListener('DOMContentLoaded', () => {
  
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  const header = document.querySelector('.header-wrapper');
  const menuDetails = document.querySelectorAll('.header__inline-menu details');

  const setHeaderPosition = () => {
    if (!header) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(header.getBoundingClientRect().bottom)}px`
    );

    header.preventHide = true;
  };

  const closeOtherMenus = (currentDetail) => {
    menuDetails.forEach((detail) => {
      if (detail === currentDetail) return;

      const summary = detail.querySelector('summary');
      detail.classList.remove('menu-opening');
      detail.removeAttribute('open');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
        // summary.blur();
      }
    });
  };

  menuDetails.forEach((detail) => {
    let closeTimeout;
    const summary = detail.querySelector('summary');
    if (!summary) return;

    const openMenu = () => {
      clearTimeout(closeTimeout);
      setHeaderPosition();
       closeOtherMenus(detail);

      detail.setAttribute('open', '');
      detail.classList.add('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      clearTimeout(closeTimeout);

      closeTimeout = setTimeout(() => {
        detail.classList.remove('menu-opening');
        detail.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        // summary.blur();

        if (header) header.preventHide = false;
      }, 350);
    };

    detail.addEventListener('mouseenter', openMenu);
    detail.addEventListener('mouseleave', closeMenu);

    ['pointerdown', 'mousedown', 'click'].forEach((eventName) => {
      summary.addEventListener(
        eventName,
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          openMenu();
        },
        true
      );
    });
  });
});



